import React from "react"

import {
	Box,
	IconButton,
} from "@mui/material"
import {
	FirstPage,
	KeyboardArrowLeft,
	KeyboardArrowRight,
	LastPage,
} from "@mui/icons-material"

export interface PaginationActionsProps
{
	count: number
	page: number
	rowsPerPage: number
	onPageChange: any
	showFirstButton: boolean
	showLastButton: boolean
	getItemAriaLabel: any
}
interface PaginationActionsState
{
	page: number
}
export class PaginationActions extends React.Component<PaginationActionsProps, PaginationActionsState>
{
	constructor(props: PaginationActionsProps)
	{
		super(props)
		this.state = {
			page: this.props.page,
		}
	}

	private handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		this.setState(
			() => ({ page: 0, }),
			() => this.props.onPageChange(event, this.state.page)
		)
	}

	private handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		if(this.state.page === 0) {
			return
		}

		this.setState(
			() => ({ page: this.state.page - 1, }),
			() => this.props.onPageChange(event, this.state.page)
		)
	}

	private handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		let isLastPage = this.state.page === Math.ceil(this.props.count / this.props.rowsPerPage) - 1
		if(isLastPage) {
			return
		}

		this.setState(
			() => ({ page: this.state.page + 1, }),
			() => this.props.onPageChange(event, this.state.page)
		)
	}

	private handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		const page = Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
		this.setState(
			() => ({ page: page, }),
			() => this.props.onPageChange(event, this.state.page)
		)
	}

	render()
	{
		return (
			<Box sx={{
				flexShrink: 0,
				ml: 2.5,
			}}>
				<IconButton
					onClick={this.handleFirstPageButtonClick}
					aria-label="first page"
				>
					<FirstPage />
				</IconButton>
				<IconButton
					onClick={this.handleBackButtonClick}
					aria-label="previous page"
				>
					<KeyboardArrowLeft />
				</IconButton>
				<IconButton
					onClick={this.handleNextButtonClick}
					aria-label="next page"
				>
					<KeyboardArrowRight />
				</IconButton>
				<IconButton
					onClick={this.handleLastPageButtonClick}
					aria-label="last page"
				>
					<LastPage />
				</IconButton>
			</Box>
		)
	}
}
